import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  width: 100vw;
  height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    padding: 10px 0px;
  }

  .email {
    display: flex;
    justify-content: center;
  }

  input {
    display: flex;
    align-items: center;
    border-radius: 5px;
    padding: 3px;
    width: 280px;
    height: 40px;
  }

  button {
    padding: 0px 20px;
    background-color: #32cd32;
    color: #fff;
    border-radius: 5px;
    border: 0 solid;
    transition: filter 0.2s;
    &:hover {
      filter: brightness(0.9);
    }

    .error-message {
      color: red;
    }
  }

  @media (max-width: 1080px) {
    input {
      width: 200px;
    }
  }
`;
